jQuery(document).ready(function ($) {
  updateCartAmount();
  $(document.body).on('added_to_cart updated_wc_div removed_from_cart updated_cart_totals', function () {
    //using update basket on the basket
    updateCartAmount();
    show_disclaimer_check();
  });
}); // Loading header login via Ajax for Fastly

function updateCartAmount() {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', ajax_object.ajax_url, true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      var result = xhr.responseText; //fetch all cart icons

      var cartIcons = document.getElementsByClassName('update-cart-amount'); //if there are cart icons

      if (cartIcons && cartIcons.length > 0) {
        //loop over them and update the amount
        for (var i = 0; i < cartIcons.length; i++) {
          cartIcons[i].innerHTML = result;
          cartIcons[i].classList.remove('hidden');
        }
      }
    } else {
      console.error(xhr.statusText);
    }
  };

  xhr.onerror = function () {
    console.error('Request failed');
  };

  var data = 'action=lr_update_cart_item_amount';
  xhr.send(data);
}

function show_disclaimer_check() {
  var cart_disclaimer_div = document.getElementById('cart-disclaimer');

  if (cart_disclaimer_div) {
    var cart_items = document.querySelectorAll('.cart_item .product-name[data-installation-disclaimer="true"]');

    if (cart_items.length > 0) {
      cart_disclaimer_div.classList.remove('hidden');
    } else {
      cart_disclaimer_div.classList.add('hidden');
    }
  }
}